import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Signatures from '../views/Signatures.vue'
import Donations from '../views/Donations.vue'
import Login from '../views/Login.vue'
import Export from '../views/Export.vue'
import Dashboard from '../views/Dashboard.vue'
import NewsletterSignups from '../views/NewsletterSignups.vue'
import CampaignConfigurationList from '../views/CampaignConfigurationList.vue'
import EditCampaignConfiguration from '../views/EditCampaignConfiguration.vue'
import Urls from '../views/Urls.vue'
import { getUserRole } from '../auth/auth.util'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/admin/login',
    name: 'login',
    component: Login
  },
  {
    path: '/admin/signatures',
    name: 'signatures',
    component: Signatures,
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/donations',
    name: 'donations',
    component: Donations,
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/newsletter-signups',
    name: 'newsletter-signups',
    component: NewsletterSignups,
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/export',
    name: 'export',
    component: Export,
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/dashboard',
    component: Dashboard,
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/campaign-configuration',
    name: 'campaign-configuration-list',
    component: CampaignConfigurationList,
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/campaign-configuration/edit/:id',
    name: 'edit-campaign-configuration',
    component: EditCampaignConfiguration,
    props: { campaignConfiguration: {}, mode: 'edit' },
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/campaign-configuration/add',
    name: 'add-campaign-configuration',
    component: EditCampaignConfiguration,
    props: { campaignConfiguration: {}, mode: 'add' },
    meta: { AdminAccessOnly: true }
  },
  {
    path: '/admin/urls',
    name: 'urls',
    component: Urls
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _from, next) => {
  const userRole = getUserRole()

  if (to.meta.AdminAccessOnly && userRole !== 'admin') {
    next('/admin/urls')
  } else {
    next()
  }
})

export default router
